import React, { useState, useContext, useRef } from 'react';
import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';

import {
  TextInput, Select, Checkbox, TextArea, Form, Button, PhoneInput,
} from 'components/common';
import { contactUsRequest } from 'models/source';
import { StatusContext } from 'contexts/statusContext';
import { emailValidator, nameValidator } from 'utils/formValidators';

const ContactUsForm = ({ t }) => {
  const { setErrorState } = useContext(StatusContext);

  const [fullName, setFullName] = useState('');
  const [company, setCompany] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [purpose, setPurpose] = useState('');
  const [note, setNote] = useState('');
  const [agreement, setAgreement] = useState('');
  const [agreement1, setAgreement1] = useState('');
  const [agreement2, setAgreement2] = useState('');

  const [onResponse, setOnResponse] = useState(false);
  const [formRef, setFormRef] = useState(useRef());

  const onFormSubmit = async () => {
    if (!onResponse) {
      try {
        setOnResponse(true);
        await contactUsRequest({
          fullName, company, email, phone, purpose, text: note,
        });
        formRef.setFieldsValue({
          fullName: '', company: '', email: '', phone: '', purpose: '', note: '', agreement: false, agreement1: false, agreement2: false,
        });
        setFullName('');
        setCompany('');
        setEmail('');
        setPhone('+90');
        setPurpose('');
        setNote('');
        setAgreement(false);
        setAgreement1(false);
        setAgreement2(false);
        setErrorState({
          title: t('successful'),
          text: 'Talebiniz başarılı bir şekilde bize ulaşmıştır.',
          buttonText: t('close'),
          type: 'success',
          onClickButton: () => setErrorState({}),
        });
      } catch (error) {
        setErrorState({
          title: t('alert'),
          text: error.message,
          buttonText: t('close'),
          onClickButton: () => setErrorState({}),
        });
      } finally {
        setOnResponse(false);
      }
    }
  };

  return (
    <div className="im-box im-box--shadow im-box--white im-box--padding-45">
      <Form
        layout="vertical"
        onFinish={onFormSubmit}
        formRef={(ref) => setFormRef(ref)}
      >
        <div className="text-center">
          <h2 className="h4 mb-45 fw-900">SİZİ ARAYALIM</h2>
        </div>
        <div className="row">
          <div className="col-15 col-sm-8 mb-3 mb-sm-0">
            <TextInput
              name="fullName"
              minLength="2"
              placeholder={t('fullName')}
              value={fullName}
              onChange={({ value }) => setFullName(value)}
              validator={nameValidator}
              required
            />
          </div>
          <div className="col-15 col-sm-7">
            <TextInput
              name="company"
              placeholder={t('company')}
              value={company}
              onChange={({ value }) => setCompany(value)}
              required
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <TextInput
              type="email"
              name="email"
              placeholder={t('email')}
              value={email}
              onChange={({ value }) => setEmail(value)}
              validator={emailValidator}
              required
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-15 mb-3 mb-sm-0">
            <PhoneInput
              name="phone"
              label={t('phoneNumber')}
              value={phone}
              onChange={({ value }) => setPhone(value)}
              required
              mobileNumber
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <Select
              name="purpose"
              placeholder={t('reasonForContactUs')}
              onChange={({ value }) => setPurpose(value)}
              value={purpose}
              options={[
                { value: 'Satış İşlemleri', text: 'Satış İşlemleri' },
                { value: 'Makina Alım İşlemleri', text: 'Makina Alım İşlemleri' },
                { value: 'Öneri', text: 'Öneri' },
                { value: 'Talep', text: 'Talep' },
                { value: 'Şikayet', text: 'Şikayet' },
                { value: 'Diğer', text: 'Diğer' },
              ]}
              required
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col">
            <TextArea
              name="note"
              placeholder={t('yourNote')}
              value={note}
              onChange={({ value }) => setNote(value)}
              required
            />
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col">
            <Checkbox
              name="agreement"
              value={agreement}
              onChange={({ value }) => setAgreement(value)}
              text="Sözleşmeyi okudum, kabul ediyorum."
              required
            />
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col">
            <Checkbox
              name="agreement1"
              value={agreement1}
              onChange={({ value }) => setAgreement1(value)}
              text="Kişisel Verilerin İşlenmesi ile İlgili Aydınlatma Metni’ni okudum."
              required
            />
          </div>
        </div>
        <div className="row mt-4 mb-4">
          <div className="col">
            <Checkbox
              name="agreement2"
              value={agreement2}
              onChange={({ value }) => setAgreement2(value)}
              text="iyiMakina.com tarafından ileti gönderilmesini, bilgilerimin bu amaçla saklanmasını, kampanya ve tekliflerden yararlanmak için E-Posta, SMS vb. iletileri ve aramaları almayı,gönderime ilişkin hizmet alınan taraflarla paylaşılmasını haklarım saklı kalmak kaydı ile kabul ediyorum."
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Button
              htmlType="submit"
              className="im-button im-button--primary im-button--fluid im-button--center"
              label={t('send')}
              loading={onResponse}
            />
          </div>
        </div>
      </Form>
    </div>
  );
};

ContactUsForm.propTypes = {
  t: PropTypes.func,
};

export default withTranslation('common')(ContactUsForm);
